import React from 'react';

const ChapterTimeline = ({ chapters, duration, currentTime, onSeek }) => {
  if (!chapters || chapters.length === 0) return null;
  return (
    <div className="flex w-full h-1.5 mb-1 gap-0.5">
      {chapters.map((chapter, idx) => {
        const widthPercent =
          ((chapter.end - chapter.start) / (duration || 1)) * 100;
        const isActive =
          currentTime >= chapter.start && currentTime < chapter.end;
        return (
          <div
            key={idx}
            className={`h-full rounded-sm cursor-pointer transition-colors relative group ${
              isActive ? 'bg-blue-500' : 'bg-white/30 hover:bg-white/60'
            }`}
            style={{ width: `${widthPercent}%` }}
            onClick={(e) => {
              e.stopPropagation();
              onSeek(chapter.start);
            }}
          >
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 bg-black/90 text-xs text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 whitespace-nowrap pointer-events-none z-10 shadow-md border border-white/10">
              {chapter.title}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ChapterTimeline;
